<template>
  <div>
     <vue-json-editor v-model="$store.state.tree" :expandedOnStart="true" @json-change="onJsonChange"></vue-json-editor>
  </div>
</template>

<script>
import vueJsonEditor from 'vue-json-editor';

export default {
  data() {
    return {

    };
  },
  components: {
    vueJsonEditor,
  },
  methods: {
    onJsonChange(data) {
      this.$store.commit('UPDATE_COMPONENTKEY');
      // this.$store.state.tree = this.tree;
      console.log('onJsonChange', this.$store.state.componentKey);
      console.log(data);
      this.$store.commit('UPDATE_TREE', data);
      setTimeout(() => {
        console.log(this.$store.state.tree);
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
